import './lottery-choose.less';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setLotteryInfo } from 'actions/lottery-select';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// 默认无抽奖状态为-1
const DEFAULT_LOTTERY = -1;
class LotteryBar extends Component {
  static propTypes = {
    lotteryId: PropTypes.number,
    setLotteryInfo: PropTypes.func,
    data: PropTypes.object,
    lottery: PropTypes.array,
    getBuyState: PropTypes.func,
    getLotteryBuyList: PropTypes.func,
    showTips: PropTypes.object,
  };
  state = {
    selectFalg: DEFAULT_LOTTERY,
    availableUser: '',
    selfBuyArr: [],
    showPrice: true,
  };

  componentWillReceiveProps(nextProps) {
    const thisProps = this.props;
    // 更新小游戏拥有状态
    if (thisProps.lottery !== nextProps.lottery) {
      const lottArr = nextProps.lottery;
      this.setinitBuyState(lottArr);
    }
  }

  async componentDidMount() {
    await this.props.getLotteryBuyList();
    const lottArr = this.props.lottery;
    if (lottArr) {
      this.setinitBuyState(lottArr);
    }
  }
  componentWillUnmount() {
    // 组件销毁时重设默认为无抽奖模式
    this.props.setLotteryInfo(DEFAULT_LOTTERY);
  }

  // 设置初始已购买状态/价格显示/已拥有身份状态
  setinitBuyState(lottArr) {
    const nowSelectLottery = this.props.lotteryId;
    let arr = [];
    lottArr.forEach(item => {
      // 当前身份已购买
      if (item.lotteryTypeId === nowSelectLottery && item.current) {
        this.setState({
          showPrice: false,
          availableUser: '',
        });
      }
      // 存储当前身份已购买
      if (item.current) {
        arr.push(item.lotteryTypeId);
      } else if (
        // 其他身份已购买提醒
        item.lotteryTypeId === nowSelectLottery &&
        !item.current &&
        item.ownerName
      ) {
        this.setState({
          availableUser: item.ownerName,
        });
      }
    });
    this.setState({
      selfBuyArr: arr,
    });
  }

  async setLottery(index) {
    this.setState({
      selectFalg: index,
      availableUser: '',
      showPrice: true,
    });
    await this.props.setLotteryInfo(index);
    this.props.getBuyState();
    const lottArr = this.props.lottery;
    lottArr.forEach(item => {
      if (index === item.lotteryTypeId && !item.current) {
        this.setState({
          availableUser: item.ownerName,
        });
      } else if (index === item.lotteryTypeId && item.current) {
        this.setState({
          showPrice: false,
        });
      }
    });
  }

  render() {
    const { selectFalg, availableUser, selfBuyArr } = this.state;
    const {
      lotterys,
      // discountPrice,
      // purchasePrice,
      // experiencePrice,
      // experienceDays,
    } = this.props.data;
    const {
      // showFreePrice,
      // haveRightTrial,
      showIsExperience,
    } = this.props.showTips;

    return (
      <div className="lottery-choose">
        <div className="lottery-bar">
          {lotterys.map(item => {
            return (
              <div
                className={classnames('option', {
                  bold: selfBuyArr.includes(item.id),
                  active: item.id === selectFalg,
                })}
                key={item.id}
                onClick={() => {
                  this.setLottery(item.id);
                }}>
                <p>{item.name}</p>
              </div>
            );
          })}

          {availableUser && !showIsExperience ? (
            <p className="user-tips">
              *可用身份为“{availableUser}”，切换到该身份后可直接创建活动
            </p>
          ) : (
            ''
          )}
          {showIsExperience ? (
            <p className="free-user-tips">当前身份已经在免费体验中</p>
          ) : (
            ''
          )}
        </div>
        {/* <div
          className={classnames('game-price', {
            hide: !showPrice || showFreePrice || !haveRightTrial,
          })}>
          <span>{discountPrice}元/年</span>
          <p>原价: {purchasePrice}元一年</p>
        </div>
        {showFreePrice && haveRightTrial ? (
          <div className="game-price-free">
            <span>
              {experiencePrice}元/{experienceDays}天
            </span>
            <p>免费体验{experienceDays}天，体验期间不限制活动创建次数</p>
          </div>
        ) : (
          ''
        )}
        {!haveRightTrial ? (
          <div className="game-not-allow">
            <span>当前身份已经体验过，欢迎您直接购买该模板</span>
          </div>
        ) : (
          ''
        )} */}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    lotteryId: state.lotteryInfo.lotteryId,
    showTips: state.lotteryInfo.showTips,
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      setLotteryInfo,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LotteryBar);
